//Notification static

const state = {
    notificationStaticMessage: ''
};

const getters = {
    notificationStaticMessage: state => {
        return state.notificationStaticMessage
    }
};

const mutations = {
    notificationStaticMessage: (state, payload) => {
        return state.notificationStaticMessage = payload
    }
};

const actions = {
    notificationStaticMessage({commit}, notification) {
        return commit('notificationStaticMessage', notification)
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}